import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, X, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

const AccessDeniedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-pink-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <div className="relative">
              <Shield className="h-8 w-8 text-red-600" />
              <X className="h-4 w-4 text-red-600 absolute -top-1 -right-1" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold text-red-700">
            Erişim Reddedildi
          </CardTitle>
          <CardDescription className="text-gray-600">
            Bu sayfaya erişim yetkiniz bulunmamaktadır.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-sm text-gray-500">
            Bu sayfayı görüntülemek için gerekli yetkiye sahip değilsiniz. 
            Lütfen sistem yöneticinizle iletişime geçin.
          </p>
          
          <div className="flex flex-col space-y-2">
            <Button
              onClick={() => navigate('/dashboard')}
              className="w-full"
              variant="outline"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Ana Sayfaya Dön
            </Button>
            
            <Button
              onClick={() => navigate(-1)}
              className="w-full"
              variant="ghost"
            >
              Geri Git
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccessDeniedPage; 